import HeaderSection from '../../Controls/MapControlDispatch/HeaderSection.js'
import StatusPanel from '../../Controls/MapControlDispatch/StatusPanel.js'
import MapContainer from '../../Controls/MapControlDispatch/MapContainer.js'
import React, { useEffect, useState, useRef } from 'react';
import { plotZonesOnMap, clearZonesFromMap } from './maphelper/zones.js';
import { useSelector } from 'react-redux';
import { getSelectedAffiliateId } from '../../../Manager/CommonDataManager.js';
import PersistStorage from '../../../utils/helpers/PersistStorage.js';
import FooterSection from './FooterSection.js';
import { toast } from 'react-toastify';
import { getAndPlotAllDepots, clearDeposFromMap } from './maphelper/Depo.js';
import MapVoice from './MapVoice/MapVoice.js';


const MapControlDispatch = (props) => {
    const { ASCSSettingData, AffiliateData } = useSelector((store) => store.combinedata);
   
    const [clearMapObjects, setClearMapObjects] = useState(false);
    const [showTripList, setShowTripList] = useState(false);
    const [showTrafficLayer, setTrafficLayer] = useState(false);
    const [MapView, setMapView] = useState(false);
    const [mapCenterAlign, setMapCenterAlign] = useState(false);
    const [showRouteInfoSection, setShowRouteInfoSection] = useState(false);
    const [isMapReset, setIsMapReset] = useState(false);
    const [IsShowCompleted, setIsShowCompleted] = useState(false);
    const [toggles, setToggles] = useState({ShowCompleted: false});

    const [IsDispatchGridDoubleClickSelectionChange, setIsDispatchGridDoubleClickSelectionChange] = useState(props.IsDispatchGridDoubleClickSelectionChange);

    const [clusterTblStateBeforeCompute, setClusterTblStateBeforeCompute] = useState(null);
    useEffect(() => {
        setClusterTblStateBeforeCompute(props.clusterTableStateBeforeCompute);
    }, [props.clusterTableStateBeforeCompute]);

    useEffect(() => {
        setIsDispatchGridDoubleClickSelectionChange(props.IsDispatchGridDoubleClickSelectionChange);
    }, [props.IsDispatchGridDoubleClickSelectionChange])

    const [showVehicles, setShowVehicles] = useState(false);
    useEffect(() => {
        if (typeof props.onShowVehiclesChange === 'function') {
          props.onShowVehiclesChange(showVehicles);
        }
    }, [showVehicles, props.onShowVehiclesChange]);


    const [showOccupiedVehicles, setShowOccupiedVehicles] = useState(false);
    useEffect(() => {
        if (typeof props.onShowOccupiedVehiclesChange === 'function') {
          props.onShowOccupiedVehiclesChange(showOccupiedVehicles);
        }
    }, [showOccupiedVehicles, props.onShowOccupiedVehiclesChange]);

    const [showCompletedTrips, setShowCompletedTrips] = useState(true);
    useEffect(() => {
        if (typeof props.onShowCompletedTripsChange === 'function') {
          props.onShowCompletedTripsChange(showCompletedTrips);
        }
    }, [showCompletedTrips, props.onShowCompletedTripsChange]);


    const [showVehicleDispatch, setShowVehicleDispatch] = useState(false);
    useEffect(() => {
        if (typeof props.onShowVehicleDispatch === 'function') {
          props.onShowVehicleDispatch(showOccupiedVehicles);
        }
    }, [showVehicleDispatch, props.onShowVehicleDispatch]);

    useEffect(() => {

    }, [props.onDeselectRow])
    
    const [isFullScreen, setIsFullScreen] = useState(false);
    const handleFullScreenToggle = () => {
        setIsFullScreen((prev) => !prev);
    };

    const [showMiniMap, setShowMiniMap] = useState(false);
    

    const selectedAff = useRef(null);
    const [affSelected, setAffSelected] = useState(()=> {
        let familySelectionMemory = PersistStorage.retrieve("_SelectedFamilyAffiliates", false);
        if(props.selectedAffiliates && props.selectedAffiliates !== ''){
            return props.selectedAffiliates;
        }
        else {
            return familySelectionMemory;
        }
    });

    useEffect( ()=>{
        //alert("Affiliate change");
        clearZonesFromMap(zones);
        setZones([]);
        setVehiclesData([]);
        setClearMapObjects(true);
    }, [props.selectedAffiliates]);

    useEffect(() => {
        //alert("date change");
    }, [props.selectedDate])
    

    
    
    const [map, setMap] = useState(null);
    const [maps, setMaps] = useState(null);
    const [zones, setZones] = useState([]);
    const [depots, setDepots] = useState([]);
    const [depoInfos, setDepoInfos] = useState([]);
    const [isZoomLocked, setIsZoomLocked] = useState(false);
    
    const mapCenterRef = useRef({ lat: 39.16, lng: -77.16 });

    const mapRef = useRef(null);
    const mapsRef = useRef(null);
    

    useEffect(() => {
         if (props.voiceAction === "PlotZonesOnMap") {
            handleToggle("Zones", true);
            setToggles(prev => ({...prev, Zones: true}));
        }
        else if(props.voiceAction === "UnPlotZonesFromMap"){
            handleToggle("Zones", false);
            setToggles(prev => ({...prev, Zones: false}));
        }
     }, [props.voiceAction])

    const handleToggle = (key, isActive) => {
        if (key === 'Zones') {
          if (isActive) {
            clearZonesFromMap(zones);
            setZones([]);
            let selectedAffTemp = (selectedAff.current ? parseInt(selectedAff.current) : parseInt(props.selectedAffiliates));
            const drawnZones = plotZonesOnMap(map, maps, selectedAffTemp);
            setZones(drawnZones);
          } else {
            clearZonesFromMap(zones);
            setZones([]);
          }
        }
        if (key === 'MiniMap') {
            setShowMiniMap(isActive);
        }
        if (key === 'Dispatch') {
            setShowVehicleDispatch(isActive);
        }
        if (key === 'TripLst') {
            setShowTripList(isActive);
        }
        if (key === 'Traffic') {
            setTrafficLayer(isActive);
        }
        if (key === 'MapView'){
            setMapView(isActive);
        }
        if(key === 'Vehicle'){
            setShowVehicles(isActive);
        }
        if(key === 'mapCenterAlign'){
            setMapCenterAlign(isActive);
        }
        if(key === "Show Occupied"){
            if(isActive){
                toast.success("Show Occupied Vehicles On. Press Reload data or wait for the next refresh.");
            }
            else{
                toast.info("Show Occupied Vehicles Off.");
            }
            setShowOccupiedVehicles(isActive);
        }
        if(key === "ShowCompleted"){
            if(isActive){
                toast.success("Show Completed Trips On.");
            }
            else{
                toast.info("Show Completed Trips Off.");
            }
            setShowCompletedTrips(isActive);
        }
        if(key === "Depot"){
            if(isActive){
                let selectedAffTemp = (selectedAff.current ? parseInt(selectedAff.current) : parseInt(props.selectedAffiliates));
                fetchAndPlotAllDepots(map, maps, props.selectedDate, selectedAffTemp);
            }
            else{
                clearDeposFromMap(depots, depoInfos);
            }
        }
        if(key === "Zoom Lock")
        {
            setIsZoomLocked(isActive);
        }
        if(key === "Routes"){
            setShowRouteInfoSection(isActive);
        }
        if(key === "ResetMap"){
            setIsMapReset(isActive);
        }
        // Handle other toggles if needed
    };
    
    const fetchAndPlotAllDepots = async (map, maps, selectedDate, affSelected) => {
        try {
            const drawnDepots = await getAndPlotAllDepots(map, maps, selectedDate, affSelected);
            setDepots(drawnDepots[0]);
            setDepoInfos(drawnDepots[1]);
        } catch (error) {
            
        }
    }
      
    const defaultZoom = 8;
    const [currentZoom, setCurrentZoom] = useState(defaultZoom);
    const handleZoomIn = () => {
        //if(!isZoomLocked){
            if (map){
                const newZoom = map.getZoom() + 1;
                map.setZoom(map.getZoom() + 1);
                setCurrentZoom(newZoom);
            }    
        //}
    };
  
    const handleZoomOut = () => {
        //if(!isZoomLocked){
            if (map){
                const newZoom = map.getZoom() - 1;
                map.setZoom(map.getZoom() - 1);
                setCurrentZoom(newZoom);
            }
            // if (map) map.setZoom(map.getZoom() - 1);
            // setCurrentZoom(newZoom);
       // }
    };



    const handleDeletedTag = (deletedConfirmationNo) => {
        console.log("Tag deleted in MapControlDispatch:", deletedConfirmationNo);
    
        // Forward to parent
        if (typeof props.onDeletedTag === 'function') {
          props.onDeletedTag(deletedConfirmationNo);
        }
    };

    const [showHeader, setShowHeader] = useState(true);

    const toggleHeaderVisibility = () => {
        setShowHeader(prev => !prev);
    };

    const IsSelectedTripRouted = useRef(false);
    useEffect(() => {
        IsSelectedTripRouted.current = props.IsRoutedTrip;

        //********** 1 Open Vehicle Dispatching Options **********//
      
        //********** 1 Open Vehicle Dispatching Options **********//

        if(props.IsRoutedTrip){
            //handleToggle("Dispatch", false);
        }
        //@@@@@@@@@@ 2 Open Routes Info Summary Section @@@@@@@@@@@@@@@//
        if(props.IsRoutedTrip){
            setToggles(prev => ({...prev, Routes: true}));
            setShowRouteInfoSection(true);
        }
        else{
            setToggles(prev => ({...prev, Routes: false}));
            setShowRouteInfoSection(false);
        }
        //@@@@@@@@@@ 2 Open Routes Info Summary Section @@@@@@@@@@@@@@@//
    }, [props.IsRoutedTrip])


   
    useEffect(() => {
        setIsShowCompleted(props.IsCheckCompletedTrips);
        setToggles({ShowCompleted: props.IsCheckCompletedTrips })
    }, [props.IsCheckCompletedTrips])
    

    const [vehicleData, setVehiclesData] = useState([]);

    useEffect(() => {
        if(props.TripType.current == "Routed-0" &&
            (Array.isArray(props.vehData) 
                && props.vehData.length > 0)){
            //setToggles(prev => ({...prev, Dispatch: false}));
            //setShowVehicleDispatch();
        }
        else{
            //setToggles(prev => ({...prev, Dispatch: false}));
            //setShowVehicleDispatch(false);
        }
        setVehiclesData(props.vehData);

    }, [props.vehData])

    return (
        
        <div className={`map-wrapper ${isFullScreen ? 'fullscreen' : ''}`} style={{display: "flex", flexDirection: "row-reverse", height: props.height, paddingLeft: "0px"}}>

           {/* <MapVoice></MapVoice> */}
            {/* {showHeader ? ( */}
                <HeaderSection
                className={showHeader ? "visible" : "hidden"}
                onToggle={handleToggle}
                onFullScreenToggle={handleFullScreenToggle}
                isFullScreen={isFullScreen}
                onZoomIn={handleZoomIn}
                onZoomOut={handleZoomOut}
                onClose={toggleHeaderVisibility}
                HideVehicleDispatching={IsSelectedTripRouted}

                initialToggles={toggles}
                />
            {/* ) : null} */}

       
            <div className="map-container-wrapper" title='Click to show the Map Controls'>
                {!showHeader && (
                <div className="folder-tab-button" onClick={toggleHeaderVisibility}>
                    <span>Controls</span>
                </div>
                )}
                            
            {/* { <StatusPanel status={props.status} tripDetails={props.tripDetails} /> } */}
          
                <MapContainer
                    center={mapCenterRef.current}
                    onMapReady={(map, maps) => {
                        setMap(map);
                        setMaps(maps);
                    }}
                    className="map-container"
                    showAllVehiclesOnMap = {showVehicles}
                    showMiniMap ={showMiniMap}
                    showVehicleDispatch = {showVehicleDispatch}
                    showTripList = {showTripList}
                    showTrafficLayer = {showTrafficLayer}
                    MapView = {MapView}
                    vehData = {vehicleData}//{props.vehData}
                    deletedTagCallback={handleDeletedTag} 
                    assignedVehicleToTrip = {props.assignedVehicleToTrip}
                    
                    handleMapHeight={props.handleRowResize}
                    height={props.height + "%"}
                    options={props.options}
                    gridType = {props.gridMainType}
                    clearMapObjects = {clearMapObjects}
                    isZoomLocked = {isZoomLocked}
                    currentZoom = {currentZoom}
                    mapCenterAlign = {mapCenterAlign}
                    showRouteInfoSection = {showRouteInfoSection}
                    isMapReset = {isMapReset}
                    DispatchVehicleData = {props.DispatchVehicleData}
                    DispatchDriverData = {props.DispatchDriverData}
                    GridRowData={props.GridRowData}
                    routedTripFromDispatchQueue = {props.routedTripFromDispatchQueue}
                    selectedTripFromDispatchQueue = {props.selectedTripFromDispatchQueue}
                    IsDispatchGridDoubleClickSelectionChange = {props.IsDispatchGridDoubleClickSelectionChange}
                    sidebarStatus = {props.sidebarStatus}
                    clusterTblStateBeforeCompute = {clusterTblStateBeforeCompute}
                    SelectedRoute = {props.SelectedRoute}
                    isCalledFromRouteDropDown = {props.isCalledFromRouteDropDown}

                />
            {/* <FooterSection  
                onZoomIn={handleZoomIn}
                onZoomOut={handleZoomOut}>
            </FooterSection> */}
        </div>
        </div>
    );
};
export default MapControlDispatch;

